import './Login.css';
import React from 'react';
import { useState } from 'react';
import Button from '../components/Button';
import { useNavigate } from 'react-router-dom';

function Login({ onLogin }) {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState(0);

    const navigate = useNavigate();

    async function login() {
        const loginInfo = { username, password };
        fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
            method: 'POST',
            body: JSON.stringify(loginInfo),
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
              }        })
            .then(response => {
                if (!response.ok) {
                    setLoginError(response.status);
                    throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
            })
            .then(data => {
                if (data.login) {
                    onLogin({ username: username, password: password, role: data.role })
                    navigate('/home');
                }
            })
            .catch(err => {
                console.log(err);
                if (loginError === 0) {
                    setLoginError(500);
                }
            });
    }

    return (
        <div className='main-login-page'>
            <h3 className='login-text'>Username:</h3>
            <input className='login-username-field login-field' value={username} onChange={e => setUsername(e.target.value)} />
            <h3 className='login-text'>Password:</h3>
            <input className='login-password-field login-field' value={password} onChange={e => setPassword(e.target.value)} />
            <Button buttonText='Login' onClickFunction={() => login()}/>
            {
                loginError === 401 ? <h5 className='error-text-login'>Invalid username or password</h5> :
                loginError > 0 ? <h5 className='error-text-login'>Error logging in</h5> : null
            }
        </div>
    )
}

export default Login;